/**
 * Взаимодействие с хранилищем браузера
 */
// конвертация в JSON, если необходимо
const encodeData = (value) => {
    if (value instanceof Object || value instanceof Array) {
        value = JSON.stringify(value);
    }

    return value;
}
// распаковка JSON, если необходимо
const decodeData = (value) => {
    try {
        return JSON.parse(value);
    } catch (e) {
        return value;
    }
}
export default {
    methods: {
        /**
         * Сохранение данных в локальное хранилище
         * @param {string} key
         * @param {string|array|object} value
         */
        setLocalStorageItem(key, value) {
            setLocalStorageItem(key, value);
        },
        /**
         * Получение данных локального хранилища
         * @param {string} key
         */
        getLocalStorageItem(key) {
            return getLocalStorageItem(key);
        },
        /**
         * Удаление данных локального хранилища
         * @param {string} key
         */
        removeLocalStorageItem(key) {
            removeLocalStorageItem(key);
        }
    },
}

/**
 * Для использования вне миксина
 */
export const setLocalStorageItem = (key, value) => {
    localStorage.setItem(key, encodeData(value));
}

export const getLocalStorageItem = (key) => {
    return decodeData(localStorage.getItem(key));
}

export const removeLocalStorageItem = (key) => {
    localStorage.removeItem(key);
}
